import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PriceContext } from '../Context/PriceContext';
import './AddServices.css';
import Mount from '../Mount';
import { Helmet } from 'react-helmet';

const AddServices = () => {
  const { paymentData, setPaymentData } = useContext(PriceContext);
  const [services, setServices] = useState(() => paymentData?.services || {});


  const [tooltip, setTooltip] = useState({ visible: false, text: '' });
  const navigate = useNavigate();
  

  useEffect(() => {
    const missingInfo = !paymentData.deliveryTurnaround || !paymentData.wordcount || !paymentData.documentType;
    if (missingInfo) {
      navigate('/');
    }
  }, [paymentData, navigate]);

  useEffect(() => {
    setServices(paymentData.services || {});
  }, [paymentData.services]);

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setServices((prevServices) => ({
      ...prevServices,
      [id]: checked,
    }));
  };

  useEffect(() => {
    setPaymentData((prevData) => ({
      ...prevData,
      services,
    }));
  }, [services, setPaymentData]);

  const handleSubmitOrderClick = (e) => {
    e.preventDefault();
    navigate('/upload');
  };

  const handleMouseEnter = (e, service) => {
    setTooltip({ visible: true, text: tooltips[service] || "No description available" });
  };
  
  const handleMouseLeave = () => {
    setTooltip({ visible: false, text: '' });
  };
  

  const tooltips = {
    DRR: "Select this option to initiate the review of lengthy documentation, to obtain specific information on a particular topic, or to initiate exhaustive web/database searches. This option does not include written responses.",
    Investigate: "Select this option to request a targeted investigation of searchable online databases or publicly accessible government resources.",
    Research: "Choose this option to initiate specialized research on a particular area of interest.",
    Design: "Select this option to initiate a project with a custom design, graphic, letterhead, or logo.",
    Review: "Select this option if the project requires a brief review of supporting documentation, other than a rough draft, to understand the scope or nature of this project.",
    Layout: "Choose this option if a document requires strict adherence to a legal, professional, or academic format/standard.",
    Merge: "Select this option to merge additional documents as enclosures into a single pdf for one FLAT RATE. File size may not exceed 10MB.",
    Audio: "Choose this option to submit an audio file or voice message (.mp3). Audio files, when combined, do not exceed 10 minutes.",
    Video: "Select this option to have a video reviewed that does not exceed a file size of 10MB.",
    Compress: "Select this option if you require a specific file size. For example, MSPB filings, pleadings, and upload cannot exceed 10MB. ",
    Convert: "All projects are returned to the client as a .pdf. Select this option for Photoshop, Adobe Illustrator, Microsoft Publisher or Microsoft Word file.",
    Consult: "Select this option to have an audio-visual conference call scheduled within 3 to 7 days. Set preferred 'Completion Date' to 72 hours or 5-7 days.",
  };

  return (
    <div className="setter">
      <Helmet>
        <title>Add Services - Contranorm Media & Production&nbsp;&trade;</title>
      </Helmet>
      <Mount>
        <div className="page">
          <h1>
            <div className="text"> Premium Services</div>
          </h1>
          <div className="underline"></div>
        
            <form onSubmit={handleSubmitOrderClick}>
              <div className='holdIt'>
                <div className="services">
                  {Object.keys(services).map((service) => (
                      <div className="service-item"
                        key={service}
                        onMouseEnter={(e) => handleMouseEnter(e, service)}
                        onMouseLeave={handleMouseLeave}>
                        <input
                          type="checkbox"
                          id={service}
                          checked={services[service]}
                          onChange={handleCheckboxChange}/>
                        <label htmlFor={service}>{service}</label>
                      </div>
                  ))}
                  <div
                    className={`tooltip ${tooltip.visible ? 'visible' : ''}`}>
                    {tooltip.text}
                  </div>
                </div>
                
              </div>
              <div className='submit-options'>
              <div className="submit-container">
                   <button type="button" className="submit gray" onClick={() => navigate('/price-calculator')}>
                    Go Back
                  </button>
                  <button type="submit" className="submit">
                    Next
                  </button>
                 
                </div>
              </div>
            </form>
            
          </div>
      </Mount>
    </div>
  );
};

export default AddServices;
